<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :form="form"
    :actions="actions"
    title="操作日志"
    resource="operation_records"
    :actionButtons="[]"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class OperationRecords extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'content_or_content_en_cont',
        label: '内容',
        renderCell: {
          component: 'input'
        }
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: '编号',
        width: 80,
        sortable: true
      },
      {
        prop: 'admin_user.email',
        label: '管理员',
        minWidth: 150
      },
      {
        prop: 'content',
        label: '内容',
        minWidth: 150
      },
      {
        prop: 'created_at',
        label: '创建时间',
        renderCell: 'time',
        sortable: true,
        minWidth: 130
      },
      {
        prop: 'updated_at',
        label: '更新时间',
        renderCell: 'time',
        sortable: true,
        minWidth: 120
      },
      type === 'show' && {
        prop: 'previous_object',
        label: '操作前数据',
        renderCell(h, { props: { value } }) {
          return <pre>{ JSON.stringify(value, undefined, 2) }</pre>
        }
      },
      type === 'show' && {
        prop: 'current_object',
        label: '操作后数据',
        renderCell(h, { props: { value } }) {
          return <pre>{ JSON.stringify(value, undefined, 2) }</pre>
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/operation_records',
    name: 'operation_records.index',
    component: OperationRecords,
    props: {
      type: 'index',
    }
  },
  // 暂时只能查看index列表
  // {
  //   path: '/operation_records/:id',
  //   name: 'operation_records.show',
  //   component: OperationRecords,
  //   props: {
  //     type: 'show',
  //   }
  // }
]
</script>
